/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Bright_Crane_FlyInputs */

const en_mild_bright_crane_fly = /** @type {(inputs: Mild_Bright_Crane_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejecting…`)
};

const de_mild_bright_crane_fly = /** @type {(inputs: Mild_Bright_Crane_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird abgelehnt…`)
};

/**
* | output |
* | --- |
* | "Rejecting…" |
*
* @param {Mild_Bright_Crane_FlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_bright_crane_fly = /** @type {((inputs?: Mild_Bright_Crane_FlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Bright_Crane_FlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_bright_crane_fly(inputs)
	return de_mild_bright_crane_fly(inputs)
});